import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

const PlanListBreadcrumb = ({ data, onClick }) => {
  const handleClick = (item, isActive) => {
    if (isActive) return void 0;

    onClick(false);
  };

  return (
    <PlanListBreadcrumbStyled listClassName="m-0">
      <BreadcrumbItem active={!data} onClick={() => handleClick(null, !data)}>
        All plans groups
      </BreadcrumbItem>
      {data !== null && <BreadcrumbItem active>{data}</BreadcrumbItem>}
    </PlanListBreadcrumbStyled>
  );
};

PlanListBreadcrumb.propTypes = {
  data: PropTypes.any,
  onClick: PropTypes.func,
};

const PlanListBreadcrumbStyled = styled(Breadcrumb)`
  user-select: none;

  ol {
    padding: 0 !important;
    padding-left: 0;
  }

  .breadcrumb-item:not(:last-child) {
    transition-duration: 0.5s;
    cursor: pointer;

    &:hover {
      color: rgb(85, 110, 230);
      transition-duration: 0.5s;
    }
  }
`;

export default PlanListBreadcrumb;
